import { Regelstufe } from './regelstufe.enum';

export enum Abregelungstyp {
    SOLLWERT = 'SOLLWERT',
    AT_100_30_0 = '100,30,0',
    AT_100_60_0 = '100,60,0',
    AT_100_60_30_0 = '100,60,30,0',
    AT_100_0 = '100,0',
}

export class AbregelungstypItem {

    public key: Abregelungstyp;
    public description: string;

    constructor(key: Abregelungstyp, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): AbregelungstypItem[] {
        return [
            new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
            new AbregelungstypItem(Abregelungstyp.AT_100_60_30_0, '100,60,30,0'),
            new AbregelungstypItem(Abregelungstyp.AT_100_60_0, '100,60,0'),
            new AbregelungstypItem(Abregelungstyp.AT_100_30_0, '100,30,0'),
            new AbregelungstypItem(Abregelungstyp.AT_100_0, '100,0'),
        ];
    }

    public static getAllForRegelstufe(regelstufe: Regelstufe | undefined): AbregelungstypItem[] {
        switch (regelstufe) {
            case Regelstufe.RS_100_30_0:
                return [
                    new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
                    new AbregelungstypItem(Abregelungstyp.AT_100_30_0, '100,30,0'),
                ];
            case Regelstufe.RS_100_60_0:
                return [
                    new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
                    new AbregelungstypItem(Abregelungstyp.AT_100_60_0, '100,60,0'),
                ];
            case Regelstufe.RS_100_60_30_0:
                return [
                    new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
                    new AbregelungstypItem(Abregelungstyp.AT_100_60_30_0, '100,60,30,0'),
                ];
            case Regelstufe.RS_100_0:
                return [
                    new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
                    new AbregelungstypItem(Abregelungstyp.AT_100_0, '100,0'),
                ];
            case Regelstufe.RS_100_TO_0:
                return [
                    new AbregelungstypItem(Abregelungstyp.SOLLWERT, 'SOLLWERT'),
                ];
            default:
                return this.getAll();

        }
    }

}

